module.exports = __webpack_public_path__ + "static/illustration-4-d738ea326c7b57cf13d80f5cea064a25.jpg";